import userImage from "./images/default-user-img.png"
import appLogo from "./images/4life_logo.png"
import brasilLogo from "./images/brasil_logo.png"
import globalHealthLogo from "./images/logo.png"
import googleIcon from "./images/google_logo.png"
import appleIcon from "./images/apple_logo.png"
import wellnessIcon from "./images/wellness.svg"
import heartIcon from "./images/heart.svg"
import stressIcon from "./images/stress.svg"
import bloodIcon from './images/blood.svg'
import bodyIcon from './images/body.svg'
import riskIcon from './images/risk.svg'
import resourcesIcon from './images/resources.svg'
import initialLogo from './images/1024-logo.png'
import languageIcon from './images/lang-icon.png'
import checkIcon from './images/check.svg'
import uploadIcon from './images/upload.svg'
import prqIcon from './images/prq.svg'
import breathIcon from './images/lungs.svg'
import maintenceImg from './images/maintence.jpg'
import heartRateImg from './images/heart-rate.png'
import normalIcon from './images/normal.svg'
import highIcon from './images/high.svg'
import verihighIcon from './images/very-high.svg'
import mildIcon from './images/mild.svg'
import lowIcon from './images/low.svg'
import pdfIcon from './images/pdf.png'
import placeHolderImg from './images/placeholder.png'
import BenefitsIcon from './images/Benefits.svg'
import fourLifeLogo from './images/fourLifeLogo.svg'
import maleImg from './images/male.png'
import femaleImg from './images/female.png'
import age from './images/age.png'
import smoke from './images/smoke.png'
import height from './images/height.png'
import weight from './images/weight.png'
import drink from './images/water.png'
import dairy from './images/dairy.png'
import fruit from './images/fruit.png'
import vegetable from './images/vegetable.png'
import wholeGrain from './images/whole-grain.png'
import sugar from './images/sugar.png'
import redMeat from './images/red-meat.png'
import fish from './images/fish.png'
import meal from './images/meal.png'
import bowel from './images/bowel-movement.png'
import sitting from './images/sitting.png'
import lightActivity from './images/light-activity.png'
import moderateActivity from './images/moderate-activity.png'
import intenseActivity from './images/intense-activity.png'
import stress from './images/stress.png'
import sleep from './images/sleep.png'
import energy from './images/energy.png'
import immune from './images/strength.png'
import QRCode from './images/QRcode.png'
import race from './images/race.png'
import activity from './images/activity.png'
import diabetic from './images/dibetic.png'
import weist from './images/waist.png'
import bloodPressure from './images/blood-presure.png'
import product1 from './images/product-1.png'
import product2 from './images/product-2.png'
import heartRateSvg from './images/heart-rate.svg'
import heartPulseSvg from './images/heart-pulse.svg'
import o2Svg from './images/o2.svg'
import stress1 from './images/stress1.svg'
import healthy4LifeScanHorizontal from './images/favicon4life-ico.svg'
import optimizeEnv from './images/bp1.png'
import bp from './images/bp2.png'

// Scan pose guideline illustrations — shown in the Start Scan guideline modal.
import scanPoseTooLowMale from './images/02-phone-too-low-male.svg'
import scanPoseTooHighMale from './images/03-phone-too-high-male.svg'
import scanPoseEyeLevelMale from './images/04-correct-distance-male.svg'
import scanPoseSideProfileMale from './images/05-side-angle-male.svg'
import scanPoseUnevenLightMale from './images/06-uneven-lighting-male.svg'
import scanPoseNoGlassesMale from './images/07-no-glasses-male.svg'


import scanPoseTooLowFemale from './images/02-phone-too-low-female.svg'
import scanPoseTooHighFemale from './images/03-phone-too-high-female.svg'
import scanPoseEyeLevelFemale from './images/04-correct-distance-female.svg'
import scanPoseSideProfileFemale from './images/05-side-angle-female.svg'
import scanPoseUnevenLightFemale from './images/06-uneven-lighting-female.svg'
import scanPoseNoGlassesFemale from './images/07-no-glasses-female.svg'

export const images = {
    userImage,
    appLogo,
    googleIcon,
    appleIcon,
    wellnessIcon,
    heartIcon,
    stressIcon,
    bloodIcon,
    bodyIcon,
    riskIcon,
    resourcesIcon,
    initialLogo,
    languageIcon,
    checkIcon,
    uploadIcon,
    prqIcon,
    breathIcon,
    maintenceImg,
    heartRateImg,
    normalIcon,
    highIcon,
    verihighIcon,
    mildIcon,
    lowIcon,
    pdfIcon,
    placeHolderImg,
    BenefitsIcon,
    fourLifeLogo,
    maleImg,
    femaleImg,
    age,
    smoke,
    height,
    weight,
    drink,
    dairy,
    fruit,
    vegetable,
    wholeGrain,
    sugar,
    redMeat,
    fish,
    meal,
    bowel,
    sitting,
    lightActivity,
    moderateActivity,
    intenseActivity,
    stress,
    sleep,
    energy,
    immune,
    QRCode,
    race,
    activity,
    diabetic,
    weist,
    bloodPressure,
    product1,
    product2,
    heartRateSvg,
    heartPulseSvg,
    o2Svg,
    stress1,
    healthy4LifeScanHorizontal,
    stress1,
    healthy4LifeScanHorizontal,
    optimizeEnv,
    bp,
    brasilLogo,
    globalHealthLogo,
    scanPoseTooLowMale,
    scanPoseTooHighMale,
    scanPoseEyeLevelMale,
    scanPoseSideProfileMale,
    scanPoseUnevenLightMale,
    scanPoseNoGlassesMale,
    scanPoseTooLowFemale,
    scanPoseTooHighFemale,
    scanPoseEyeLevelFemale,
    scanPoseSideProfileFemale,
    scanPoseUnevenLightFemale,
    scanPoseNoGlassesFemale,
}